/**
 * AbilityRandomShooter.js
 * Implements the RandomShooter enemy ability
 */

import { Ability } from "./Ability";
import { Common } from "../Common";

import { ENEMY_ABILITY_PARTICLE_CANNON_TARGET_X, ENEMY_ABILITY_PARTICLE_CANNON_TARGET_Y } from "../../Constants";

export class AbilityRandomShooter extends Ability {
    /**
     * @public
     * @param {Number} nbBubbles
     * @param {{x: Number, y: Number}} startPos
     * @param {Function} callback
     */
    constructor(nbBubbles, startPos, callback) {
        super();

        /** @private @type {Number} */
        this._nbBubbles = nbBubbles;

        /** @private @type {Function} */
        this._callback = callback;

        // Ability particle targetting the cannon
        const targetX = ENEMY_ABILITY_PARTICLE_CANNON_TARGET_X;
        const targetY = ENEMY_ABILITY_PARTICLE_CANNON_TARGET_Y;
        Common.particles.createEnemyAbilityParticle(startPos.x, startPos.y, targetX, targetY, this._onAbilityParticleCompleted.bind(this));
    }

    /**
     * @private
     */
    _onAbilityParticleCompleted() {
        Common.shooter.addRandomBubbles(this._nbBubbles);

        if (this._callback) {
            this._callback();
        }
    }

    /**
     * @public
     */
    destroy() {
        this._callback = null;
    }
}
